import { type PimProductV11 } from '@redteclab/api/clients/bully'

import {
  CROSS_SELL_PDP_BUY_TOGETHER_WITH,
  type CrossSellConfigContext,
} from '../../../cross-sell'

export const crossSellAccessorIsExceptionFlagActiveInProduct = ({
  crossSellConfig,
  currentVariant,
}: {
  crossSellConfig: CrossSellConfigContext
  currentVariant: PimProductV11
}): boolean => {
  const exceptionFlagsForType =
    crossSellConfig.exceptionFlags?.[CROSS_SELL_PDP_BUY_TOGETHER_WITH]

  return Boolean(
    exceptionFlagsForType?.some((flag) => currentVariant.flags?.[flag]?.active),
  )
}
